import React, { useRef } from "react";
import { MdPassword } from "react-icons/md";
import { LockSharp, EditLocationSharp } from "@mui/icons-material";

interface Props {
  handleInputChange?: any;
  autoComplete?: string;
  calling_code?: string;
  isRequired?: boolean;
  autoFocus?: boolean;
  isDisabled?: boolean;
  placeholder: string;
  labelText?: string;
  labelName: string;
  hidden?: boolean;
  isValid?: boolean;
  styles?: string;
  icon?: string;
  info?: string;
  value: string;
  type: string;
  id: string;
  /** Multi-line field (e.g. address) */
  multiline?: boolean;
  rows?: number;
}

const InputField = (props: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const multiline = Boolean(props.multiline);
  const isFieldFocused =
    document.activeElement === inputRef.current ||
    document.activeElement === textareaRef.current;

  return (
    <div className={`${props.styles ?? ""} `} hidden={props.hidden}>
      <div
        className={`flex justify-between w-full border-2 border-gray-100 rounded-md p-2 mb-2 ${
          multiline ? "items-start" : "items-center"
        }`}
        style={{
          borderColor: isFieldFocused
            ? props.isValid
              ? "rgba(243, 244, 246, var(--tw-border-opacity))"
              : "red"
            : "rgba(243, 244, 246, var(--tw-border-opacity))",
        }}
      >
        {props.labelName === "phone" && (
          <div className="inline-flex">
            <img
              src={props.icon || "https://assets.ipstack.com/flags/sn.svg"}
              className="h-5 object-cover border-2 rounded-sm"
              alt="Country flag"
            />
            <span className="w-14 px-1 text-sm">{`${props.calling_code ?? ""}`}</span>
          </div>
        )}
        {props.labelName === "code" && (
          <span className="inline-flex">
            <MdPassword size={28} />
          </span>
        )}
        {props.labelName === "address" && (
          <span className={`inline-flex ${multiline ? "mt-1 shrink-0" : ""}`}>
            <EditLocationSharp />
          </span>
        )}
        {props.labelName === "password" && (
          <span className="inline-flex">
            <LockSharp />
          </span>
        )}
        {multiline ? (
          <textarea
            id={props.id}
            ref={textareaRef}
            value={props.value}
            name={props.labelName}
            disabled={props.isDisabled}
            autoFocus={props.autoFocus}
            placeholder={props.placeholder}
            rows={props.rows ?? 4}
            onChange={(e) => props.handleInputChange?.(e)}
            className="border-none min-h-[3.5rem] w-full flex-1 min-w-0 resize-y outline-none text-sm px-2 py-1.5 rounded-md ml-1 caret-black"
            autoComplete={props.autoComplete}
          />
        ) : (
          <input
            id={props.id}
            ref={inputRef}
            type={props.type}
            value={props.value}
            name={props.labelName}
            disabled={props.isDisabled}
            autoFocus={props.autoFocus}
            placeholder={props.placeholder}
            onChange={(e) => props.handleInputChange?.(e)}
            className={`border-none w-full outline-none text-sm px-2 py-1 rounded-md ml-1 caret-black`}
            autoComplete={props.autoComplete}
          />
        )}
      </div>
    </div>
  );
};

export default InputField;
